import React from 'react';
import PropTypes from 'prop-types';
import ValidatingForm from '../forms/validating_form';
import EmailField from '../fields/email_field';
import PasswordField from '../fields/password_field';
import PasswordConfirmationField from '../fields/password_confirmation_field';

class LoginInfo extends ValidatingForm {
  requiredFieldNames() {
    return [
      'email',
      'password',
      'password_confirmation',
    ];
  }

  componentDidUpdate(prevProps, prevState){
    if(JSON.stringify(this.state.erroredFields) !== JSON.stringify(prevState.erroredFields)){
      this.props.updateFormError(this._reactInternalFiber.type.name.toLowerCase(), this.state.erroredFields)
    }
  }

  render() {
    return (
      <div>
        <div className='input-error'>{ this.state.errorMessage }</div>
        <form className='ordination-form'>
        <label>
            <h3 className='form-section-title'>Your Login Credentials</h3>
            <div className='l-row'>
              <EmailField
                required
                name='email'
                displayName='Email'
                updateModel={ this.props.updateModel }
                updateErrorMessage={ this.updateErrorMessage }
                value={ this.props.minister.email }
                onError={ this.addError }
                onValid={ this.removeError }
                className='l-columns-600-4 margin-b-10'/>
              <PasswordField
                required
                name='password'
                displayName='Password'
                updateModel={ this.props.updateModel }
                updateErrorMessage={ this.updateErrorMessage }
                value={ this.props.minister.password }
                onError={ this.addError }
                onValid={ this.removeError }
                className='l-columns-600-4 margin-b-10'/>
              <PasswordConfirmationField
                required
                name='password_confirmation'
                displayName='Confirm Password'
                updateModel={ this.props.updateModel }
                updateErrorMessage={ this.updateErrorMessage }
                value={ this.props.minister.password_confirmation }
                onError={ this.addError }
                onValid={ this.removeError }
                password={ this.props.minister.password }
                className='l-columns-600-4'/>
            </div>
          </label>
        </form>
      </div>
    );
  }
};

LoginInfo.propTypes = {
  minister: PropTypes.object.isRequired,
  updateModel: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  updateFormError: PropTypes.func.isRequired
};

export default LoginInfo;
